import { connect, mapProps } from '@formily/vue'
import CollapseImgItem from './CollapseImg.vue'

const CollapseImg = connect(CollapseImgItem, mapProps({ readOnly: 'readonly' }))

export default CollapseImg
